import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  background: ${themeColor('background.primary')};
`;

export const Banner = styled.div`
  position: relative;
  height: 100vh;
  width: 50%;
  border-top-right-radius: 150px;
  overflow: hidden;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const BannerImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: left;
  filter: blur(1px);
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.8));
`;

export const LogoPosition = styled.div<{ isMobile?: boolean }>`
  position: absolute;
  bottom: 36px;
  right: 36px;

  svg,
  img {
    width: 197px;
    height: 35px;
  }
`;

export const Main = styled.main`
  flex: 1;
`;

export const MainContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 40px;
  background-color: ${themeColor('background.primary')};
  background-image: url('/assets/imgs/TpontoOutline.png');
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 460px;
  min-width: 100%;

  @media (min-width: 768px) {
    padding: 0 124px;
    min-width: max(50%, 615px);
  }

  /* Inputs use background.primary so the field, its hover state and the autofill
     inset (also background.primary) all match — otherwise the filled area shows as a
     lighter stripe over a darker field. Keep the antd input/affix-wrapper transparent
     so the container color shows through (antd's light CSS otherwise paints them white). */
  .mt-input {
    background-color: ${themeColor('background.primary')} !important;

    .ant-input,
    .ant-input-affix-wrapper {
      background-color: transparent !important;
    }

    /* Typed/autofilled value must follow the theme text color instead of the browser's
       default white — otherwise it reads as a bright line over the dark field. */
    .ant-input,
    .ant-input-affix-wrapper input {
      color: ${themeColor('element.primary')} !important;
      -webkit-text-fill-color: ${themeColor('element.primary')} !important;
    }
  }

  /* Google login button text/icon stays white in both themes. */
  .google-button {
    color: #ffffff !important;

    .typography,
    svg {
      color: #ffffff !important;
    }
  }
`;

export const ContentWrapper = styled.div`
  @media (min-width: 768px) {
    max-width: 384px;
  }
`;

export const LogoWrapper = styled.img`
  //display: none;
  display: block;
  object-fit: cover;
  margin-bottom: 56px;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.typography?.fonts.montserrat};
  color: ${themeColor('element.primary')};
`;

// Form.tsx styled components
export const FormContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: none;
  flex-direction: column;
  gap: 1.5rem;

  @media (min-width: 768px) {
    max-width: 384px;
  }
`;

export const FormMessage = styled.p`
  font-size: 1rem;
  color: ${themeColor('element.primary')};
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;

export const OrText = styled.span`
  text-align: center;
  color: ${themeColor('element.secondary')};
  font-size: 0.875rem;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${themeColor('divider.primary')};
  margin-top: 0.5rem;
`;

export const AccessInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const AccessText = styled.span`
  font-size: 0.875rem;
  color: ${themeColor('element.secondary')};
`;

export const AccessLink = styled.a`
  display: flex;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 0.875rem;
  color: ${themeColor('brand.primary')};
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`;
